import { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'
import { useDialogStore, type DialogValue } from '../../stores/dialogStore'
import DialogCard from './DialogCard'

export default function DialogHost() {
  const queue = useDialogStore((s) => s.queue)
  const resolveTop = useDialogStore((s) => s.resolveTop)
  const active = queue[0]
  const [leaving, setLeaving] = useState(false)
  const pendingValue = useRef<DialogValue>(undefined)
  const timerRef = useRef<number | null>(null)

  // Reset the leaving flag whenever a new dialog becomes active.
  useEffect(() => { setLeaving(false) }, [active?.id])
  // Clear a pending exit timer if the host unmounts mid-animation.
  useEffect(() => () => { if (timerRef.current) clearTimeout(timerRef.current) }, [])

  if (!active) return null

  const beginClose = (value: DialogValue) => {
    if (leaving) return
    pendingValue.current = value
    setLeaving(true)
    timerRef.current = window.setTimeout(() => resolveTop(pendingValue.current), 150) // play exit, then resolve + dequeue
  }

  return createPortal(
    <DialogCard key={active.id} dialog={active.options} leaving={leaving} onResolve={beginClose} />,
    document.body,
  )
}
